import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ringVideo from '../assets/ringff-2.mp4';
import BookingModal from './BookingModal';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative h-screen overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover filter blur-sm"
          style={{ transform: `translateY(${scrollY * 0.3}px)` }}
        >
          <source src={ringVideo} type="video/mp4" />
        </video>
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Floating diamonds animation */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 text-6xl text-gold-400/20 animate-float">♦</div>
        <div className="absolute top-40 right-20 text-4xl text-gold-400/20 animate-float" style={{ animationDelay: '2s' }}>♦</div>
        <div className="absolute bottom-40 left-1/3 text-5xl text-gold-400/20 animate-float" style={{ animationDelay: '4s' }}>♦</div>
        <div className="absolute bottom-20 right-1/4 text-3xl text-gold-400/20 animate-float" style={{ animationDelay: '1s' }}>♦</div>
      </div>

      {/* Main content */}
      <div className="relative h-full flex items-center justify-center px-6">
        <div className="max-w-6xl mx-auto text-center">
          <div className="mb-8 animate-fade-in">
            <span className="inline-block px-6 py-2 text-gold-400 font-montserrat text-xs tracking-super-wide border border-gold-400/30 rounded-full">
              FOR OVER 40 YEARS
            </span>
          </div>
          
          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight animate-slide-up">
            Welcome to
            <span className="block text-gold-400 mt-2">Master Jewelers</span>
          </h1>
          
          <p className="font-cormorant text-xl md:text-2xl text-white/80 mb-8 max-w-3xl mx-auto leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
            Serving North Georgia with no middlemen, no markups. Just honest family craftsmanship with a lifetime guarantee.
          </p>

          {/* Service Categories */}
          <div className="flex flex-wrap justify-center gap-6 mb-12 animate-slide-up" style={{ animationDelay: '0.3s' }}>
            {['Custom Engagement Rings', 'Natural & Lab Grown Diamonds', 'While-You-Wait Repairs', 'Vintage Designs', 'Watches', 'Bespoke Jewelry'].map((category, index) => (
              <span
                key={category}
                className="text-gold-300 font-montserrat text-sm tracking-wider opacity-90"
                style={{ animationDelay: `${0.3 + (index * 0.1)}s` }}
              >
                {category.toUpperCase()}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center animate-slide-up" style={{ animationDelay: '0.5s' }}>
            <button 
              onClick={() => setIsBookingModalOpen(true)}
              className="group relative px-10 py-4 bg-gradient-gold text-white font-montserrat text-sm tracking-wider overflow-hidden transition-all duration-300 hover:scale-105"
            >
              <span className="relative z-10">DESIGN YOUR RING</span>
              <div className="absolute inset-0 bg-gold-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </button>
            
            <Link to="/repair-estimate" className="px-10 py-4 border-2 border-white/50 text-white font-montserrat text-sm tracking-wider hover:border-gold-400 hover:text-gold-400 transition-all duration-300 inline-block text-center">
              GET REPAIR ESTIMATE
            </Link>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cream to-transparent"></div>
      
      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        isFromRepair={false}
      />
    </section>
  );
};

export default Hero;